module.exports = __webpack_public_path__ + "static/img/1068_big.5f09df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1068_big.png
// module id = vwvd
// module chunks = 1